module.exports = __webpack_public_path__ + "img/en_bubble.699627f.png";